<template>
    <div class="card mb-2">
        <div class="card-header">
            <div class="collapsed card-link" data-parent="#accordion">
                Felvétel
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Munkát felvette*</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <v-select
                                id="recorder"
                                :options="users"
                                v-model="recorder"
                                single
                                :disabled="disabled"
                            >
                                <div slot="no-options">Nincs a keresésnek megfelelő találat.</div>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="record-time">Felvétel dátuma*</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <v-date-picker
                                mode='single'
                                v-model='worksheet.recordTime'
                                style="width: 100%"
                            >
                                <input slot-scope='props'
                                       id="record-time"
                                       type="text"
                                       class="form-control form-control-sm"
                                       :value="props.inputValue"
                                       @change='props.updateValue($event.target.value)'
                                       :disabled="disabled"
                                >
                            </v-date-picker>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Felvétel státusza*</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <v-select
                                id="record-status"
                                :options="statusOptions"
                                v-model="worksheet.recordStatus"
                                taggable
                                push-tags
                                :disabled="disabled"
                            >
                                <div slot="no-options">Új státusz megadásához gépelje be, majd üssön ENTER-t.</div>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'RecordData',
        data() {
            return {
                recorder: null
            }
        },
        props: {
            users: {
                type: Array,
                required: true
            },
            statusOptions: {
                type: Array,
                required: true
            },
            worksheet: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            recorder(){
                if(this.recorder !== null){
                    this.worksheet.recorder = this.recorder.value;
                }
            },
            "worksheet.recorder"(){
                if(this.worksheet.recorder !== null){
                    let user = this.users.find(item => {
                        return item.value === this.worksheet.recorder;
                    });

                    this.recorder = user;
                }
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/worksheet/RecordData.vue